export function buildUrl(template, params = {}) {
    let url = template;
    for (const key in params) {
        url = url.replace(`:${key}`, params[key]);
    }
    return url;
}
//# sourceMappingURL=build-url.js.map